import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
    HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable, Injector, Optional } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { ITokenModel } from './interface';
import { Router } from '@angular/router';
import { API_CONFIG } from '../config';
import { SERVICE_TOKEN, ITokenService } from './interface';
import { AuthService } from '../../setting/auth.service';

class HttpAuthInterceptorHandler implements HttpHandler {
  constructor(private next: HttpHandler, private interceptor: HttpInterceptor) {}

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.interceptor.intercept(req, this.next);
  }
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  model: ITokenModel = {
    accessToken: "",
    expiresIn: 0
  }

  constructor(
    @Optional() protected injector: Injector
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // トークンの情報をチェックする必要がないURLの場合
    if (Array.isArray(API_CONFIG.ignores)) {
      for (const item of API_CONFIG.ignores) {
        if (item.test(req.url)) return next.handle(req);
      }
    }

    // リクエストパラメータ中にallow_anonymous_keyがある場合
    const ingoreKey = API_CONFIG.allow_anonymous_key!;
    let ingored = false;
    let params = req.params;
    let url = req.url;
    if (req.params.has(ingoreKey)) {
      params = req.params.delete(ingoreKey);
      ingored = true;
    }
    const urlArr = req.url.split('?');
    if (urlArr.length > 1) {
      const queryStringParams = new HttpParams({ fromString: urlArr[1] });
      if (queryStringParams.has(ingoreKey)) {
        const queryString = queryStringParams.delete(ingoreKey).toString();
        url = queryString.length > 0 ? `${urlArr[0]}?${queryString}` : urlArr[0];
        ingored = true;
      }
    }
    if (ingored) {
      return next.handle(req.clone({ params, url }));
    }

    // アクセストークンがあるかどうかをチェックする
    if (this.isAuth()) {
      req = this.setReq(req);
    } else {
      this.toLogin();
      // エラー情報
      const err$ = new Observable((observer: Observer<HttpEvent<any>>) => {
        const res = new HttpErrorResponse({
          url: req.url,
          headers: req.headers,
          status: 401,
          statusText: `アクセス権限なし`,
        });
        observer.error(res);
      });
      if (API_CONFIG.executeOtherInterceptors) {
        const interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
        const lastInterceptors = interceptors.slice(interceptors.indexOf(this) + 1);
        if (lastInterceptors.length > 0) {
          const chain = lastInterceptors.reduceRight((_next, _interceptor) => new HttpAuthInterceptorHandler(_next, _interceptor), {
            handle: (_: HttpRequest<any>) => err$,
          });
          return chain.handle(req);
        }
      }
      return err$;
    }
    return next.handle(req);
  }

  /**
   * アクセストークンがあるかどうかをチェックする
   */
  isAuth(): boolean {
    this.model = this.injector.get(SERVICE_TOKEN).get() as ITokenModel;
    return this.checkToken(this.model as ITokenModel);
  }

  /**
   * HTTPヘッダー中にアクセストークン情報を追加する
   */
  setReq(req: HttpRequest<any>): HttpRequest<any> {
    const { token_send_key } = API_CONFIG;
    const token = this.model.accessToken;
    const obj: any = {};
    obj[token_send_key] = token;
    req = req.clone({
      setHeaders: obj,
    });
    if(API_CONFIG.log) {
      console.log(`%c[@API]:${req.method}->${req.urlWithParams}->request`, 'color:#eb5e0b', req);
    }
    return req;
  }

  /**
   * アクセストークンがあるかどうかをチェックする
   * アクセストークンが自動的にリフレッシュされたので、アクセストークンは常に有効
   */
  checkToken(model: ITokenModel | null): boolean {
    return model != null && typeof model.accessToken === 'string' && model.accessToken.length > 0;
  }

  /**
   * ログイン画面に遷移する
   */
  toLogin(url?: string): void {
    const router = this.injector.get<Router>(Router);
    (this.injector.get(SERVICE_TOKEN) as ITokenService).referrer!.url = url || router.url;
    if (API_CONFIG.token_invalid_redirect === true) {
      setTimeout(() => {
        //this.injector.get(AuthService).deleteAllLocalInfo();
        router.navigate([API_CONFIG.login_url]);
      });
    }
  }

}
  